import React, { useContext, useState, useCallback} from 'react'
import { UserContext } from 'stores/UserStore'
import safety from 'api/safety'
import { toast } from 'react-toastify'

export const SafetyStockContext = React.createContext({})

export const SafetyStockProvider = ({ children }) => {

    const { idToken } = useContext(UserContext)
    const [isLoading, setLoading] = useState(false)
    const [isLoadingModal, setLoadingModal] = useState(false)
    const [tableData, setTableData] = useState([])
    const [extractTableData, setExtractTableData] = useState([])
    const [chartPiecesByCustomerData, setchartPiecesByCustomerData] = useState([])
    const [chartPiecesByApplicationData, setchartPiecesByApplicationData] = useState([])
    const [chartPiecesByMaterialData, setChartPiecesByMaterialData] = useState([])
    const [filter, setFilter] = useState([])
   
    const getSafetyStockData = () => {
        setLoading(true)
        safety.getSafetyStock(idToken, 'init').then(data => {
            if (typeof data === 'string')
                data = JSON.parse(data);

            data = data.body ? data.body : data
            // console.debug(data)
            setTableData(data.tableData)
            setchartPiecesByCustomerData(data.chartPiecesByCustomer)
            setchartPiecesByApplicationData(data.chartPiecesByApplication)
            setChartPiecesByMaterialData(data.chartPiecesByMaterial)
            setLoading(false)
        }).catch(error => {
            console.debug(error)
        })
    }

    const getSafetyStockExtractData = (id) => {
        setLoadingModal(true)
        safety.getSafetyStock(idToken, 'extract', id).then(data => {
            if (typeof data === 'string')
                data = JSON.parse(data);

            data = data.body ? data.body : data
            console.debug(data)
            setExtractTableData(data.tableData)
            setLoadingModal(false)
        }).catch(error => {
            console.debug(error)
        })
    }

    const getSafetyStockRegisterNm = useCallback((params) => new Promise((resolve, reject) => {
        setLoading(true)
        safety.getSafetyStockRegister(idToken, 'init').then(data => {
            if (typeof data === 'string')
                data = JSON.parse(data);
            data = data.body ? data.body : data
            setLoading(false)
            resolve(data)
        }).catch(e => {
            toast.error(e.errorMessage)
            reject(e)
          }).finally(() => setLoading(false)) 
      }), [idToken]) 


    const SafetyStockCrudRegisterNm = useCallback((params) => new Promise((resolve, reject) => {
        setLoading(true)
        safety.CrudSafetyStockRegister(idToken, params).then(data => {
            if (typeof data === 'string')
                data = JSON.parse(data);
            data = data.body ? data.body : data
            setLoading(false)
            resolve(data)
        }).catch(e => {
            toast.error(e.errorMessage)
            reject(e)
          }).finally(() => setLoading(false)) 
    }), [idToken]) 

    const getSafetyStockPlanningNm = useCallback((params) => new Promise((resolve, reject) => {
        setLoading(true)
        safety.getSafetyStockPlanning(idToken, 'init').then(data => {
            if (typeof data === 'string')
                data = JSON.parse(data);
            data = data.body ? data.body : data
            setLoading(false)
            resolve(data)
        }).catch(e => {
            toast.error(e.errorMessage)
            reject(e)
          }).finally(() => setLoading(false)) 
    }), [idToken]) 

    const safetyStockCrudPlanning = useCallback((params) => new Promise((resolve, reject) => {
        setLoading(true)
        safety.crudSafetyStockPlanning(idToken, params).then(data => {
            if (typeof data === 'string')
                data = JSON.parse(data);
            data = data.body ? data.body : data
            setLoading(false)
            resolve(data)
        }).catch(e => {
            toast.error(e.errorMessage)
            reject(e)
          }).finally(() => setLoading(false)) 
    }), [idToken])
    
    return (
            <SafetyStockContext.Provider value={{
                tableData,
                chartPiecesByCustomerData,
                chartPiecesByApplicationData,
                chartPiecesByMaterialData,
                isLoading,
                extractTableData,
                isLoadingModal,
                getSafetyStockData,
                getSafetyStockExtractData,
                getSafetyStockRegisterNm,
                filter,
                setFilter,
                SafetyStockCrudRegisterNm,
                getSafetyStockPlanningNm,
                safetyStockCrudPlanning
            
            }}>
                {children}
            </SafetyStockContext.Provider>
        )
}